import { Component } from '@angular/core';

@Component({
  selector: 'mode-notebook-container',
  templateUrl: './notebook-container.component.html',
  styleUrls: ['./notebook-container.component.scss'],
})
export class NotebookContainerComponent {
  constructor() {}
}
